import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApiInstance from "app/services/axios";
import { DATASOURCE_CONFIG } from "app/config";
import {
  getBidsDashboardDataEndPoint,
  getDashboardPreInfoDataEndPoint,
  getDataEndPoint,
  updateDataEndPoint,
} from "app/utils/constants/paths";
let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  dashboardPreInfoLoader: false,
  graphData: [],
  tilesData: {},
  dashboardPreInfo: {},
  dashboardType: "",
};

export const GetGraphAndSummaryDataThunk = createAsyncThunk(
  "analyticdashboard/GetGraphAndSummaryDataThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getBidsDashboardDataEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetDashboardPreInfoDataThunk = createAsyncThunk(
  "analyticdashboard/GetDashboardPreInfoDataThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getDashboardPreInfoDataEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
const AnalyticsDashboard = createSlice({
  name: "AnalyticsDashboard",
  initialState,
  reducers: {
    resetAnalyticsDashboardSliceData(state, action) {
      state.graphData = {};
      state.tilesData = {};
      state.dashboardPreInfo = [];
    },
    updateDashboardType(state, action) {
      state.dashboardType = action.payload.dashboardType;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetGraphAndSummaryDataThunk.pending, (state) => {})
      .addCase(GetGraphAndSummaryDataThunk.fulfilled, (state, action) => {})
      .addCase(GetGraphAndSummaryDataThunk.rejected, (state) => {})
      .addCase(GetDashboardPreInfoDataThunk.pending, (state) => {
        state.dashboardPreInfoLoader = true;
      })
      .addCase(GetDashboardPreInfoDataThunk.fulfilled, (state, action) => {
        if (Object.keys(action.payload.data?.results).length > 0) {
          let preInfoResult = action.payload.data?.results;
          preInfoResult["dashboardType"] = action.meta.arg?.dataview;
          //console.log("preInfoResult:", preInfoResult);
          state.dashboardPreInfo = preInfoResult;
          //state.dashboardType = action.meta.arg?.dataview;
          //state.dashboardPreInfo[]
        }
        state.dashboardPreInfoLoader = false;
      })
      .addCase(GetDashboardPreInfoDataThunk.rejected, (state) => {
        state.dashboardPreInfoLoader = false;
      });
  },
});

const { actions, reducer } = AnalyticsDashboard;
export const { resetAnalyticsDashboardSliceData, updateDashboardType } =
  actions;
export default reducer;
